import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import * as React from "react";
import isArrayEqual from "./isArrayEqual";
import NavigationBuilderContext from "./NavigationBuilderContext";
import NavigationRouteContext from "./NavigationRouteContext";
export default function useOnGetState(param) {
    var getState = param.getState, getStateListeners = param.getStateListeners;
    var addKeyedListener = React.useContext(NavigationBuilderContext).addKeyedListener;
    var route = React.useContext(NavigationRouteContext);
    var key = route ? route.key : "root";
    var getRehydratedState = React.useCallback(function() {
        var state = getState();
        // Avoid returning new route objects if we don't need to
        var routes = state.routes.map(function(route) {
            var _getStateListeners_route_key;
            var childState = (_getStateListeners_route_key = getStateListeners[route.key]) === null || _getStateListeners_route_key === void 0 ? void 0 : _getStateListeners_route_key.call(getStateListeners);
            if (route.state === childState) {
                return route;
            }
            return _object_spread_props(_object_spread({}, route), {
                state: childState
            });
        });
        if (isArrayEqual(state.routes, routes)) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            routes: routes
        });
    }, [
        getState,
        getStateListeners
    ]);
    React.useEffect(function() {
        return addKeyedListener === null || addKeyedListener === void 0 ? void 0 : addKeyedListener("getState", key, getRehydratedState);
    }, [
        addKeyedListener,
        getRehydratedState,
        key
    ]);
}
